module.exports = __webpack_public_path__ + "img/paw.cdb32d9f.svg";